"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withLinks = exports.withImages = exports.UINEditor = void 0;
var _helpers = require("../../utils/helpers");
var _slate = require("slate");
var _constants = require("../../utils/constants");
var _escapeHtml = _interopRequireDefault(require("escape-html"));
var _UINEditor;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var withLinks = exports.withLinks = function withLinks(editor) {
  var insertData = editor.insertData,
    insertText = editor.insertText,
    isInline = editor.isInline;
  editor.isInline = function (element) {
    return element.type === 'link' ? true : isInline(element);
  };
  editor.insertText = function (text) {
    if (text && (0, _helpers.isValidURL)(text)) {
      UINEditor.wrapLink(editor, text);
    } else {
      insertText(text);
    }
  };
  editor.insertData = function (data) {
    var text = data.getData('text/plain');
    if (text && (0, _helpers.isValidURL)(text)) {
      UINEditor.wrapLink(editor, text);
    } else {
      insertData(data);
    }
  };
  return editor;
};
var withImages = exports.withImages = function withImages(editor) {
  var insertData = editor.insertData,
    isVoid = editor.isVoid,
    normalizeNode = editor.normalizeNode;
  editor.normalizeNode = function (entry) {
    var _entry = _slicedToArray(entry, 2),
      node = _entry[0],
      path = _entry[1];
    if (_slate.Element.isElement(node) && node.type === 'image') {
      if (path[0] === editor.children.length - 1) {
        _slate.Transforms.insertNodes(editor, {
          type: 'paragraph',
          children: [{
            text: '',
            font: 'Arial',
            size: '14px'
          }]
        });
        return;
      }
    }
    normalizeNode(entry);
  };
  editor.isVoid = function (element) {
    return element.type === 'image' ? true : isVoid(element);
  };
  editor.insertData = function (data) {
    var text = data.getData('text/plain');
    var files = data.files;
    if (files && files.length > 0) {
      var _iterator = _createForOfIteratorHelper(files),
        _step;
      try {
        var _loop = function _loop() {
          var file = _step.value;
          var reader = new FileReader();
          var _file$type$split = file.type.split('/'),
            _file$type$split2 = _slicedToArray(_file$type$split, 1),
            mime = _file$type$split2[0];
          if (mime === 'image') {
            reader.addEventListener('load', function () {
              var url = reader.result;
              UINEditor.insertImage(editor, url);
            });
            reader.readAsDataURL(file);
          }
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } else if ((0, _helpers.isImageURL)(text)) {
      UINEditor.insertImage(editor, text);
    } else {
      insertData(data);
    }
  };
  return editor;
};
var UINEditor = exports.UINEditor = (_UINEditor = {
  currentMark: function currentMark(editor, name) {
    var marks = _slate.Editor.marks(editor);
    return marks ? marks[name] : null;
  },
  isMarkActive: function isMarkActive(editor, name, value) {
    var marks = _slate.Editor.marks(editor);
    return marks ? marks[name] === value : false;
  },
  toggleMark: function toggleMark(editor, name, value) {
    var isActive = UINEditor.isMarkActive(editor, name, value);
    if (isActive) _slate.Editor.removeMark(editor, name);
    _slate.Editor.addMark(editor, name, value);
  },
  activeAlign: function activeAlign(editor) {
    var _Editor$nodes = _slate.Editor.nodes(editor, {
        match: function match(n) {
          return n.align;
        }
      }),
      _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
      match = _Editor$nodes2[0];
    return match ? match[0].align : null;
  },
  isAlignActive: function isAlignActive(editor, align) {
    var _Editor$nodes3 = _slate.Editor.nodes(editor, {
        match: function match(n) {
          return n.align === align;
        }
      }),
      _Editor$nodes4 = _slicedToArray(_Editor$nodes3, 1),
      match = _Editor$nodes4[0];
    return !!match;
  },
  toggleAlign: function toggleAlign(editor, align) {
    var isActive = UINEditor.isAlignActive(editor, align);
    _slate.Transforms.setNodes(editor, {
      align: isActive ? undefined : align
    });
  },
  isTypeActive: function isTypeActive(editor, type) {
    var _Editor$nodes5 = _slate.Editor.nodes(editor, {
        match: function match(n) {
          return n.type === type;
        }
      }),
      _Editor$nodes6 = _slicedToArray(_Editor$nodes5, 1),
      match = _Editor$nodes6[0];
    return !!match;
  },
  toggleType: function toggleType(editor, type) {
    var isActive = UINEditor.isTypeActive(editor, type);
    var isList = _constants.LIST_TYPES.includes(type);
    _slate.Transforms.unwrapNodes(editor, {
      match: function match(n) {
        return _constants.LIST_TYPES.includes(n.type);
      },
      split: true
    });
    _slate.Transforms.setNodes(editor, {
      type: isActive ? 'paragraph' : isList ? 'list-item' : type
    });
    if (!isActive && isList) {
      var block = {
        type: type,
        children: []
      };
      _slate.Transforms.wrapNodes(editor, block);
    }
  },
  wrapLinkUpdate: function wrapLinkUpdate(editor, url, text, prevurl, prevText) {
    var point = UINEditor.getLinkNodePath(editor, prevurl, prevText);
    _slate.Transforms.removeNodes(editor, {
      at: point
    });
    UINEditor.wrapLink(editor, url, text, {
      at: point
    });
  },
  getLinkNodePath: function getLinkNodePath(editor, prevurl, prevText) {
    for (var firstChild = 0; firstChild < editor.children.length; firstChild++) {
      for (var secondChild = 0; secondChild < editor.children[firstChild].children.length; secondChild++) {
        if (editor.children[firstChild].children[secondChild].type === "link" && editor.children[firstChild].children[secondChild].children[0].text === prevText && editor.children[firstChild].children[secondChild].url === prevurl) {
          var point = [firstChild, secondChild];
          return point;
        }
      }
    }
  },
  unwrapLink: function unwrapLink(editor) {
    _slate.Transforms.unwrapNodes(editor, {
      match: function match(n) {
        return n.type === 'link';
      }
    });
  },
  wrapLink: function wrapLink(editor, url, text, options) {
    if (UINEditor.isTypeActive(editor, 'link')) {
      UINEditor.unwrapLink(editor);
    }
    var selection = editor.selection;
    var isCollapsed = selection && _slate.Range.isCollapsed(selection);
    var link = {
      type: 'link',
      url: url,
      children: !selection || isCollapsed ? [{
        text: text || url
      }] : []
    };
    if (!selection || isCollapsed) {
      if (options) {
        _slate.Transforms.insertNodes(editor, link, options);
      } else {
        _slate.Transforms.insertNodes(editor, link);
      }
    } else {
      _slate.Transforms.wrapNodes(editor, link, {
        split: true
      });
      _slate.Transforms.collapse(editor, {
        edge: 'end'
      });
    }
  },
  changTypeLinkNode: function changTypeLinkNode(editor, url, text) {
    var point = UINEditor.getLinkNodePath(editor, url, text);
    var pointAux = _toConsumableArray(point);
    pointAux[0] = editor.children.length;
    pointAux[pointAux.length - 1] = pointAux[pointAux.length - 1] - 1;
    _slate.Transforms.removeNodes(editor, {
      at: point
    });
    _slate.Transforms.insertNodes(editor, {
      type: 'paragraph',
      children: [{
        text: text,
        font: 'Arial',
        size: '14px'
      }]
    });
    _slate.Transforms.moveNodes(editor, {
      at: pointAux,
      to: point
    });
  },
  insertImage: function insertImage(editor, url) {
    var image = {
      type: 'image',
      url: url,
      children: [{
        text: ''
      }]
    };
    _slate.Transforms.insertNodes(editor, image);
  }
}, _defineProperty(_UINEditor, "insertImage", function insertImage(editor, url, name, isAzure) {
  var image = {
    type: 'image',
    url: url,
    name: name,
    isAzure: isAzure,
    children: [{
      text: ''
    }]
  };
  _slate.Transforms.insertNodes(editor, image);
}), _defineProperty(_UINEditor, "deleteMark", function deleteMark(editor) {
  _slate.Editor.removeMark(editor);
}), _defineProperty(_UINEditor, "getNodeList", function getNodeList(editor, type) {
  var auxedit = _objectSpread({}, editor);
  for (var firstChild = 0; firstChild < auxedit.children.length; firstChild++) {
    if (auxedit.children[firstChild].type === type) {
      return firstChild;
    }
  }
}), _defineProperty(_UINEditor, "serialize", function serialize(node) {
  if (_constants.LIST_TYPES[0] === node.type) {
    var data = node.children.map(function (n) {
      return UINEditor.serialize(n);
    }).join('');
    var n = _slate.Node.get(node, [0, 0]);
    return "<ol style=\"".concat(n.color ? "color: ".concat(n.color, "; ") : '').concat(n.font ? "font-family: ".concat(_constants.FONTS[n.font], "; ") : '').concat(n.size ? "font-size: ".concat(n.size, "; ") : '', "\"> ").concat(data, " </ol>");
  }
  if (_constants.LIST_TYPES[1] === node.type) {
    var _data = node.children.map(function (n) {
      return UINEditor.serialize(n);
    }).join('');
    var _n = _slate.Node.get(node, [0, 0]);
    return "<ul style=\"".concat(_n.color ? "color: ".concat(_n.color, "; ") : '').concat(_n.font ? "font-family: ".concat(_constants.FONTS[_n.font], "; ") : '').concat(_n.size ? "font-size: ".concat(_n.size, "; ") : '', "\"> ").concat(_data, " </ul>");
  }
  if (node.type === 'list-item') {
    var _data2 = node.children.map(function (n) {
      return UINEditor.serialize(n);
    }).join('');
    return "<li> ".concat(_data2, " </li>");
  }
  if (_slate.Text.isText(node)) {
    return "<span style=\"".concat(node.color ? "color: ".concat(node.color, "; ") : '').concat(node.font ? "font-family: ".concat(_constants.FONTS[node.font], "; ") : '').concat(node.size ? "font-size: ".concat(node.size, "; ") : '', "\">").concat((0, _escapeHtml["default"])(node.text), "</span>");
  }
  var children = node.children.map(function (n) {
    return UINEditor.serialize(n);
  }).join('');
  switch (node.type) {
    case 'paragraph':
      return "<div".concat(node.align ? " style=\"text-align: ".concat(node.align, ";\"") : '', ">").concat(children, "</div>");
    case 'link':
      return "<a href=\"".concat((0, _escapeHtml["default"])(node.url), "\">").concat(children, "</a>");
    case 'image':
      if (node.isAzure) {
        return "<div".concat(node.align ? " style=\"text-align: ".concat(node.align, ";\"") : '', "><div><img alt=\"\" src=\"cid:").concat(node.name, "\" /></div>").concat(children, "</div>");
      } else {
        return "<div".concat(node.align ? " style=\"text-align: ".concat(node.align, ";\"") : '', "><div><img alt=\"\" src=\"").concat((0, _escapeHtml["default"])(node.url), "\" /></div>").concat(children, "</div>");
      }
    default:
      return children;
  }
}), _defineProperty(_UINEditor, "resetSelection", function resetSelection(editor) {
  _slate.Transforms.select(editor, [0]);
}), _UINEditor);


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/MailEditor/SlateUtils.js
// module id = 377
// module chunks = 0